<mat-accordion class="selected-cq-preview">
    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title class="selected-title">{{title}} ({{selectedCodingQuestions?.length}})
            </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-accordion>
            <mat-expansion-panel *ngFor="let cq of selectedCodingQuestions; let cqIdx = index"
                (opened)="opened(cq, cqIdx)">
                <mat-expansion-panel-header>
                    <mat-panel-title class="question-title">
                        <span class="cq-number">Q{{cqIdx + 1}}.</span>
                        <angular-editor [(ngModel)]="cq.questionText" id="{{cqIdx}}" [config]="config"></angular-editor>
                    </mat-panel-title>
                    <mat-panel-description>
                        <button mat-button color="primary" (click)="$event.stopPropagation();removeCq(cq)">
                            Remove
                        </button>
                    </mat-panel-description>
                </mat-expansion-panel-header>

                <ng-container>
                    <span class="cq-number">Answer:</span>
                    <div class="app-ace-editor" id="selected-ace-editor-{{cqIdx}}{{from}}" #selectedQPrevCodeEditor>
                    </div>
                    <span class="cq-number">Output:</span>
                    <div class="test-output">
                        <div class="test-header-ok-title">Success: {{testCaseResults.success}}</div>
                        <div class="test-header-error-title">Failed: {{testCaseResults.failure}}</div>
                        <div class="test-header-error-title" *ngIf="testCaseResults?.errored">Error:
                            {{testCaseResults.errored}}</div>
                        <div class="test-header-title">Total: {{testCaseResults?.success + testCaseResults?.failure +
                            testCaseResults?.errored}}</div>
                    </div>
                </ng-container>

                <ng-container>
                    <div class="cq-footer">
                        <div class="tags">
                            <span class="t-heading">Time : </span>
                            <span class="t-label">{{cq?.totalMinDuration}} {{cq?.totalMinDuration === 1 ? 'min' :
                                'mins'}}</span>
                            <span class="t-heading">Languages : </span>
                            <mat-chip-listbox>
                                <mat-chip *ngFor="let lang of cq.questionSignatures; let langIdx = index"
                                    (click)="opened(cq, cqIdx, langIdx); toggleLangSelect(cq, lang);" color="primary"
                                    class="language chip-with-icon"
                                    [ngClass]="{'active': !lang.isUnlinkedFromAssessment}" matChipAvatar>
                                    <mat-icon *ngIf="!lang.isUnlinkedFromAssessment">
                                        done
                                    </mat-icon>
                                    {{lang?.functionSignature?.code_language}}
                                </mat-chip>
                            </mat-chip-listbox>
                            <span class="t-heading" *ngIf="cq?.tags?.length">Tags : </span>
                            <span *ngFor="let tag of cq.tags" class="t-label"> <span class="t-dot"></span>
                                {{tag}}</span>
                        </div>
                        <div class="levels">
                            <span class="l-heading">DIFFICULTY LEVEL : </span>
                            <span class="l-label">
                                <span class="l-dot" [ngClass]="{'low-level': cq.difficultyLevel === 'LOW',
                                    'medium-level': cq.difficultyLevel == 'MEDIUM',
                                    'high-level': cq.difficultyLevel === 'HIGH'}">
                                </span>
                                {{cq.difficultyLevel}}
                            </span>
                        </div>
                        <div class="custom-snack" *ngIf="snackcontent">{{snackcontent}}</div>
                    </div>
                </ng-container>
            </mat-expansion-panel>
        </mat-accordion>
    </mat-expansion-panel>
</mat-accordion>